import { FC, useEffect, useState } from 'react'
import { CreateVariant } from '../../../MasterTabsProvider';
import BaseDocumentCreator from '../../../../components/documents/baseDocumentCreator';
import { PluginWrapper } from '../../../../components/plugins';
import { useTranslation } from 'react-i18next';
import { IExportJson, IExportToolsDTO } from '../../../../libs/coreapi-dto/dirs/exportDocument';
import { EncodingType, IdTableVariant, TypeDbf } from '../../../../@types/enumsGlobal';
import { SelectControl } from '../../../../components/controls/SelectControl';
import { IOption } from '../../../../components/selects/select';
import GridWrapper from '../../../../components/controls/GridWrapper';
import { NumberInput, TextInput } from '../../../../components/controls/inputs';
import { v4 as uuidv4 } from 'uuid';
import { ExportDocumentDataProvider } from '../../../../Services/DataProviders/ExportDocumentDataProvider';
import { useAppContext } from '../../../../system/providers/appContextProvider';
import { Accordion } from '../../../../components/controls/accordion';

interface IExportDocumentToolsCreateProps {
    ok: (data: IExportToolsDTO) => void;
    save: (data: IExportToolsDTO) => void;
    cancel: VoidFunction;
    variant: CreateVariant;
    data: IExportToolsDTO | null;
    lockFromPermission?: boolean
}

export const ExportDocumentToolsCreate: FC<IExportDocumentToolsCreateProps> = (props) => {
    const appCtx = useAppContext()
    const exportProvider = new ExportDocumentDataProvider(appCtx.coreApiService)

    const maxLength = 10;

    const [data, setData] = useState<IExportToolsDTO>(props.data ?? {encoding: EncodingType.windows, idTableVariant: IdTableVariant.InvoiceOut,name: '',settings: ''})
    
    const [jsonModel, setJsonModel] = useState<IExportJson>({Header: '', Items: ''})

    const [jsonHeader, setJsonHeader] = useState<any>()
    const [jsonItems, setJsonItems] = useState<any>()

    const onChangeData = (value, key: string): void => setData(prev => ({ ...prev, [key]: value }))

    const onChangeModel = (value,key: string, field: string = 'Name', objectName: string = 'Header') => setJsonModel(prevState => ({...prevState,
        [objectName]: {
            ...prevState[objectName],
        [key]: {
            ...prevState[objectName][key],
            [field]: value
        }
        }
    }))

    const { t } = useTranslation();
    const baseT = (value: string) => t('directory.exportDocumentTools.' + value)
    const documentsBaseT = (value: string) => t('document.' + value)
    const typeBaseT = (value: string) => t('type.' + value)

    const encodingOptions = ([
        {displayName: EncodingType.windows, value: EncodingType.windows},
        {displayName: EncodingType.ASCII, value: EncodingType.ASCII},
        //{displayName: EncodingType.Auto, value: EncodingType.Auto},
        //{displayName: EncodingType.UTF16, value: EncodingType.UTF16},
        {displayName: EncodingType.UTF8, value: EncodingType.UTF8},
        {displayName: EncodingType.ascii, value: EncodingType.ascii},
        //{displayName: EncodingType.base64, value: EncodingType.base64},
        {displayName: EncodingType.cp866, value: EncodingType.cp866},
    ]) as IOption[]

    //Пока есть реализация только для расходнгых накладных
    const idTableVariantOptions = [
        // {displayName: documentsBaseT(IdTableVariant[IdTableVariant.Invoice]), value: IdTableVariant.Invoice},
        // {displayName: documentsBaseT(IdTableVariant[IdTableVariant.ActDeduction]), value: IdTableVariant.ActDeduction},
        // {displayName: documentsBaseT(IdTableVariant[IdTableVariant.ActDisagregation]), value: IdTableVariant.ActDisagregation},
        // {displayName: documentsBaseT(IdTableVariant[IdTableVariant.ActDisassembling]), value: IdTableVariant.ActDisassembling},
        // {displayName: documentsBaseT(IdTableVariant[IdTableVariant.ActReturnToContractor]), value: IdTableVariant.ActReturnToContractor},
        // {displayName: documentsBaseT(IdTableVariant[IdTableVariant.Cheque]), value: IdTableVariant.Cheque},
        // {displayName: documentsBaseT(IdTableVariant[IdTableVariant.ImportRemains]), value: IdTableVariant.ImportRemains},
        // {displayName: documentsBaseT(IdTableVariant[IdTableVariant.InternetOrder]), value: IdTableVariant.InternetOrder},
        // {displayName: documentsBaseT(IdTableVariant[IdTableVariant.InventorySved]), value: IdTableVariant.InventorySved},
        // {displayName: documentsBaseT(IdTableVariant[IdTableVariant.InventoryVed]), value: IdTableVariant.InventoryVed},
        {displayName: documentsBaseT(IdTableVariant[IdTableVariant.InvoiceOut]), value: IdTableVariant.InvoiceOut},
        // {displayName: documentsBaseT(IdTableVariant[IdTableVariant.Movement]), value: IdTableVariant.Movement},
    ] as IOption[]

    const typeDbfOptions = [
        {displayName: typeBaseT(TypeDbf[TypeDbf.numeric]), value: TypeDbf.numeric},
        {displayName: typeBaseT(TypeDbf[TypeDbf.string]), value: TypeDbf.string},
        {displayName: typeBaseT(TypeDbf[TypeDbf.boolean]), value: TypeDbf.boolean},
        {displayName: typeBaseT(TypeDbf[TypeDbf.float]), value: TypeDbf.float},
        {displayName: typeBaseT(TypeDbf[TypeDbf.dateTime]), value: TypeDbf.dateTime},
    ] as IOption[]

    useEffect(() => {
        if (props.variant !== "create" || !data.idTableVariant) return
        exportProvider.getDefault(data?.idTableVariant, setData)
    },[data?.idTableVariant])

    useEffect(()=> {
        if (!data.settings) return
        const model: IExportJson = JSON.parse(data.settings);
        setJsonModel(model)
    },[data.settings])

    useEffect(() => {
      if(!jsonModel || 
          !jsonModel.Header ||
          !jsonModel.Items ||
          jsonModel.Header == '' ||
          jsonModel.Items == '') return
      setJsonHeader(Object.entries(jsonModel?.Header))
      setJsonItems(Object.entries(jsonModel?.Items))
    },[jsonModel])

    return (
        <BaseDocumentCreator
            ok={{
                onClick: () => {
                    props.ok({...data,settings: JSON.stringify(jsonModel)});
                },
            }}
            save={{
                onClick: () => {
                    props.save({...data,settings: JSON.stringify(jsonModel)});
                },
            }}
            cancel={{ onClick: () => props.cancel() }}
        >
            <PluginWrapper>
                
                <GridWrapper cols={3}>
                    <TextInput
                        inputId={uuidv4()}
                        label={baseT('name')}
                        value={data?.name}
                        onChange={(value) => onChangeData(value, 'name')}
                        disabled={props.lockFromPermission}
                    />
                    <SelectControl
                        label={baseT('encoding')}
                        value={encodingOptions.find(c => c.value == data?.encoding) ?? encodingOptions[0]}
                        options={encodingOptions}
                        onSelect={(value) => onChangeData(value.value, 'encoding')} 
                        disabled={props.lockFromPermission}
                    />
                    <SelectControl
                        label={baseT('idTableVariant')}
                        value={idTableVariantOptions.find(c => c.value == data?.idTableVariant) ?? idTableVariantOptions[0]}
                        options={idTableVariantOptions}
                        onSelect={(value) => onChangeData(value.value, 'idTableVariant')} 
                        disabled={props.lockFromPermission}
                    />

                </GridWrapper>
                
                 <Accordion opened={true} caption={baseT('header')} id={uuidv4()} >
                    {jsonHeader && jsonHeader.map((item) => {
                    return( 
                        <GridWrapper cols={3}> 
                            <TextInput
                                inputId={uuidv4()}
                                label={`${item[0]} - ${baseT(item[0])}`}
                                value={item[1].Name}
                                onChange={(value) => onChangeModel(value,item[0],'Name')}
                                maxTextLength={maxLength}
                            />
                            {item[1].Type != TypeDbf.boolean && item[1].Type != TypeDbf.dateTime ?
                            <NumberInput
                                label={baseT('sizeType')}
                                value={item[1].SizeType}
                                onChange={(value) => onChangeModel(value,item[0],'SizeType')}
                            /> : <div></div>}
                            <SelectControl
                                label={baseT('type')}
                                value={typeDbfOptions.find(c => c.value == item[1].Type) ?? typeDbfOptions[0]}
                                options={typeDbfOptions}
                                onSelect={(value) => onChangeModel(value.value,item[0],'Type')} 
                                disabled={props.lockFromPermission}
                             />
                        </GridWrapper>)
                    })}
                </Accordion>

                <Accordion opened={true} caption={baseT('items')} id={uuidv4()} >
                    {jsonItems && jsonItems.map((item) => {
                    return( 
                        <GridWrapper cols={3}> 
                            <TextInput
                                inputId={uuidv4()}
                                label={`${item[0]} - ${baseT(item[0])}`}
                                value={item[1].Name}
                                maxTextLength={12}
                                onChange={(value) => onChangeModel(value,item[0],'Name',"Items")}
                            />
                            {item[1].Type != TypeDbf.boolean && item[1].Type != TypeDbf.dateTime ?
                            <NumberInput
                                label={baseT('sizeType')}
                                value={item[1].SizeType}
                                onChange={(value) => onChangeModel(value,item[0],'SizeType',"Items")}
                            /> : <div></div>}
                            <SelectControl
                                label={baseT('type')}
                                value={typeDbfOptions.find(c => c.value == item[1].Type) ?? typeDbfOptions[0]}
                                options={typeDbfOptions}
                                onSelect={(value) => onChangeModel(value.value,item[0],'Type',"Items")} 
                                disabled={props.lockFromPermission}
                             />
                        </GridWrapper>)
                    })}
                </Accordion>

            </PluginWrapper>
        </BaseDocumentCreator>
    )
}